import { FC } from "react";
import { List } from "lucide-react";
import { BooleanVoidFunc } from "../../../helpers/functions/types";
import { mergeClassNames } from "../../../helpers";
import { LARGE_ICON_SIZE_STYLES } from "../../styles";

import { ExtendedViewIcon } from "../../icons";
import { NamedRadio } from "../molecules/NamedRadio";

const styleIcon = (isSelected: boolean) =>
  mergeClassNames(
    LARGE_ICON_SIZE_STYLES,
    isSelected
      ? "dark:text-stone-300 text-stone-500"
      : "text-stone-300 dark:text-stone-500",
  );
export const ToggleExtended: FC<{
  setExtended: BooleanVoidFunc;
  extended: boolean;
}> = ({ setExtended, extended }) => {
  return (
    <NamedRadio
      title="View"
      options={[
        {
          value: "short",
          icon: <List className={styleIcon(!extended)} />,
        },
        {
          value: "extended",
          icon: <ExtendedViewIcon className={styleIcon(extended)} />,
        },
      ]}
      onChange={(value) => setExtended(value === "extended")}
      radioVariant="icons"
      value={extended ? "extended" : "short"}
    />
  );
};
